export default "__VITE_ASSET__$s1liQPX__"